import { isObject } from "lodash";

export function isAnchor(element: unknown): element is HTMLAnchorElement {
    return isObject(element) && (element as HTMLElement).tagName === 'A';
}
